import { render } from "@/components/pages/individualWorkSupport/requirement035/Requirement035.html?vue&type=template&id=700a2521&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement035/Requirement035.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement035/Requirement035.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement035/Requirement035.scss?vue&type=style&index=0&id=700a2521&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700a2521"]])

export default __exports__